import { $api } from "@/shared/api";

// Справочники обновляются раз в сутки (задача `matches.sync_assets`), за сессию не меняются.
const ASSETS_STALE_TIME_MS = 60 * 60_000;

// Справочники героев и предметов: названия и иконки для `hero_id` и `item_id`.
export const useAssets = () =>
  $api.useQuery("get", "/api/matches/assets", undefined, {
    staleTime: ASSETS_STALE_TIME_MS,
    gcTime: Infinity,
  });
